module.exports = __webpack_public_path__ + "img/PRprinting3.25b7a4c0.png";